import { UseQueryResult } from '@tanstack/react-query';
import { Dispatch } from 'react';
import { IFormDto, PatchFormConfigDto } from 'src/services/api/api-client';
import { createContext } from 'use-context-selector';

export type SaveFormOptions = Pick<
  PatchFormConfigDto,
  'isMultiInstance' | 'canBeSkipped' | 'isPatientCreationForm' | 'type' | 'allowedForNotStartedPatients'
>;

export type FormConfigContextType = {
  saveFormOptions: SaveFormOptions;
  setSaveFormOptions?: Dispatch<React.SetStateAction<SaveFormOptions>>;
  currentFormConfig: IFormDto | null;
  setCurrentFormConfig?: (newFormConfig: IFormDto | null) => void;
  formConfigs?: UseQueryResult<IFormDto[], unknown>;
};

const defaultValues: FormConfigContextType = {
  currentFormConfig: null,
  saveFormOptions: {
    canBeSkipped: false,
    isMultiInstance: false,
    isPatientCreationForm: false,
    allowedForNotStartedPatients: false,
  },
};

export const FormConfigContext = createContext(defaultValues);
